import { render } from "./Protection.vue?vue&type=template&id=756b4d5e&scoped=true"
import script from "./Protection.vue?vue&type=script&lang=js"
export * from "./Protection.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-756b4d5e"

export default script